import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomCommentsCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M16 14.7V8.1H8v7.244l.585-.644zm-1-1.1v-1.1H9v1.1zm0-2.75H9v1.1h6zm0-.55V9.2H9v1.1zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2M7.005 8.1c0-.605.445-1.1.995-1.1h8c.55 0 1 .495 1 1.1v6.6c0 .605-.45 1.1-1 1.1H9L7 18z"
  />,
  'CustomCommentsCircular',
);

export default CustomCommentsCircular;
